import styled from 'styled-components'

const Header = styled.header`
	padding: var(--sp2-5x) var(--containerPadding);
	background: var(--black);
	position: relative;
	overflow: hidden;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 3;
	/* transform: translateY(-100%); */

	.burgerMenuIcon {
        width: var(--sp6-5x);
		.LottieWrap {
            margin-left: var(--sp3x);
		}
	}
`

export default Header
